import { UniqueIdentifier } from '@dnd-kit/core';
import Brightness from '@mui/icons-material/Brightness1';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight, TypographyStyledGlobal } from '../../../theme';
import ColorPickerModal from '../ColorPickerModal/colorPickerModal';
import { ColorSwatchBoxProps } from './colorSwatchModalInterface';
import { ColorContainerStyled, ColorSwatchBoxStyled, EditColorIconStyled } from './styled';

const ColorSwatchBox: FC<ColorSwatchBoxProps> = ({ colorIndex, color, handleChangeColor }) => {
    const [openColorPickerModal, setOpenColorPickerModal] = useState<boolean>(false);
    const { t } = useTranslation('settings');
    const handleChangeFillColor = (id: UniqueIdentifier | number, newColor: string | undefined) => {
        const idToUpdate = id as number;
        if (newColor) {
            handleChangeColor(idToUpdate, newColor);
        }
    };

    return (
        <>
            <ColorSwatchBoxStyled onClick={() => setOpenColorPickerModal(true)}>
                <ColorContainerStyled>
                    <Brightness
                        /* eslint-enable */
                        sx={{ color }}
                    />
                    <TypographyStyledGlobal color={colors.grey200} fontSize={fontSize.sm} fontWeight={fontWeight.regular}>
                        {`${t('colorSwatches.color')} ${color}`}
                    </TypographyStyledGlobal>
                </ColorContainerStyled>
                <EditColorIconStyled />
            </ColorSwatchBoxStyled>
            <div
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
                role="presentation"
            >
                <ColorPickerModal codemodalite={colorIndex} fillColor={color} handleChangeFillColor={handleChangeFillColor} openModal={openColorPickerModal} setOpenModal={setOpenColorPickerModal} />
            </div>
        </>
    );
};

export default ColorSwatchBox;
